import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ProgramExitTypeNature } from '@app/shared/enums/program-exit-type-nature.enum';
import { getProgramExitTypeNatureImage } from '@app/shared/utils/get-enum/get-program-exit-type-nature';

export class ProgramExitTypeSelectorApiModel {
  public Id: number;
  public Name: string;
  public Nature: ProgramExitTypeNature;
  public imgSrc: SafeResourceUrl;

  public deserialize?(data: object, domSanitizer: DomSanitizer): this {
    Object.assign(this, data);

    this.imgSrc = getProgramExitTypeNatureImage(this.Nature, domSanitizer);

    return this;
  }
}
